// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__JEn1M","resendInfoText":"OnGoingPaymentBox_resendInfoText__3jXSN"};